export default "__VITE_ASSET__BhAbnueB__"